import { useState, useCallback } from "react";
export const useRoleModal = ({ onModalClose }) => {
  const [modalMode, setModalMode] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);

  const modalOpen = modalMode !== null;

  const closeModal = useCallback(() => {
    if (typeof onModalClose === "function") {
      onModalClose();
    }
    setModalMode(null);
    setSelectedRole(null);
  }, [onModalClose]);

  const openCreateModal = useCallback(() => {
    if (typeof onModalClose === "function") {
      onModalClose();
    }
    setSelectedRole(null);
    setModalMode("create");
  }, [onModalClose]);

  const openEditModal = useCallback((role) => {
    setSelectedRole(role);
    setModalMode("edit");
  }, []);

  return {
    modalMode,
    modalOpen,
    selectedRole,
    openCreateModal,
    openEditModal,
    closeModal,
  };
};

export default useRoleModal;
